import { Box, Chip, Typography } from '@mui/material';
import { ViewAccessType } from '@/entities/session';
import { getViewsRestrictionsCount } from '../../libs/getViewsRestrictionsCount';
import { CLSType, type RoleRules } from '../../model/types';

const chipSx = {
  backgroundColor: '#F1F3F8',
  color: '#646874',
  fontWeight: 500,
} as const;

interface Props {
  rules: RoleRules;
}

export function RoleRulesPreview({ rules }: Props) {
  const chips: string[] = [];

  if (rules.capabilities?.userManagement === ViewAccessType.DENIED)
    chips.push('No User Management');
  if (rules.capabilities?.mcpAccess === ViewAccessType.DENIED)
    chips.push('No MCP Access');

  const viewCount = rules.viewsRestrictions
    ? getViewsRestrictionsCount(rules.viewsRestrictions)
    : 0;
  if (viewCount > 0)
    chips.push(`${viewCount} view restriction${viewCount !== 1 ? 's' : ''}`);

  const rlsCount = rules.rlsFilters?.dimensionFilters?.length ?? 0;
  if (rlsCount > 0)
    chips.push(`${rlsCount} row filter${rlsCount !== 1 ? 's' : ''}`);

  const clsCount = rules.clsFilters?.columns?.length ?? 0;
  if (clsCount > 0) {
    const typeLabel =
      rules.clsFilters?.type === CLSType.WHITELIST ? 'whitelist' : 'blacklist';
    chips.push(`${clsCount} column${clsCount !== 1 ? 's' : ''} ${typeLabel}`);
  }

  if (chips.length === 0)
    return (
      <Typography variant="body2" sx={{ color: '#7E828F' }}>
        —
      </Typography>
    );

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {chips.map((label) => (
        <Chip key={label} label={label} size="small" sx={chipSx} />
      ))}
    </Box>
  );
}
